module.exports = __webpack_public_path__ + "static/media/teachers_day.983ed715.jpg";